import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';
import { Link } from 'react-router-dom';
import { paymentDetailsLink } from '../../paymentHistory/utils';

const renderTotalCell = (remainingTotal, row) => {
	return ui.formatAmount(remainingTotal) + (row.refundedTotal ? ` (${ui.formatAmount(row.refundedTotal)
		})` : '');
};

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('PaymentHistory_Id'),
			accessor: 'id',
			sortable: true,
			cell: (id, row) => <Link to={paymentDetailsLink(row.category.id, id)} >{id}</Link>
		},
		{
			header: t('PaymentHistory_Category'),
			accessor: 'category',
			sortable: false,
			cell: (category) => category && <span>{category.displayName}</span>
		},
		{
			header: t('PaymentHistory_Center'),
			accessor: 'center',
			sortable: true
		},
		{
			header: t('PaymentHistory_Total'),
			accessor: 'remainingTotal',
			sortable: true,
			cell: renderTotalCell
		},
		{
			header: t('PaymentHistory_OutstandingTotal'),
			accessor: 'outstandingTotal'
		},
		{
			header: t('PaymentHistory_DiscountAmount'),
			accessor: 'discount',
			sortable: true
		},
		{
			header: t('PaymentHistory_PaymentDate'),
			accessor: 'paymentDate',
			sortable: true,
			cell: (paymentDate) => (ui.formatDateTime(paymentDate))
		},
		{
			header: t('CampaignStats_CampaignName'),
			accessor: 'campaignTags',
			sortable: false,
			cell: (campaignTags) => {
				return campaignTags && <span>{campaignTags['utm_campaign']}</span>
			}
		}

	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);